"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderTabs = void 0;
var ProviderTabs_1 = require("./ProviderTabs");
Object.defineProperty(exports, "ProviderTabs", { enumerable: true, get: function () { return __importDefault(ProviderTabs_1).default; } });
//# sourceMappingURL=index.js.map